
export default  function AlertsApi(data,pageAlerts=null,formAlerts=null) {
    if ( data.hasOwnProperty("alerts")) {
        let alerts = data.alerts;
        if(pageAlerts!=null){
            if(pageAlerts.current!=null){
                let l=alerts.length;
                for (let i=0;i<l;i++){
                    pageAlerts.current.appendXP(alerts[i].type,alerts[i].message);
                }
            }
        }
    }
    if ( data.hasOwnProperty("errorsForm")) {
        let errors = data.errorsForm;
        if(formAlerts!=null) {
            if(formAlerts.current!=null){
                let l=errors.length;
                for (let i=0;i<l;i++) {
                    formAlerts.current.appendUL(errors[i].list);
                }
            }
        }
    }
}